import Cookies from 'js-cookie';
import { setAxiosHeaders } from '~/common/js/axios';

const isProd = import.meta.env.VITE_DOMAIN_ENV === 'production' && import.meta.env.PROD;
const isTesting = import.meta.env.VITE_DOMAIN_ENV === 'testing' && import.meta.env.PROD;


// AppsFlyer 接入
if (isProd) {
  !(
    function (
      t: { AppsFlyerSdkObject: string; AF: any },
      e: Document,
      n: string,
      s: number,
      a: string,
      c: string,
      i: any,
      o: any,
      p: any
    ) {
      (t.AppsFlyerSdkObject = a),
        (t.AF =
          t.AF ||
          function () {
            (t.AF.q = t.AF.q || []).push([Date.now()].concat(Array.prototype.slice.call(arguments)));
          }),
        (t.AF.id = t.AF.id || i),
        (t.AF.plugins = {}),
        (o = e.createElement(n)),
        (p = e.getElementsByTagName(n)[0]),
        (o.async = 1),
        (o.src =
          'https://websdk.appsflyer.com?' +
          (c.length > 0 ? 'st=' + c.split(',').sort().join(',') + '&' : '') +
          (i.length > 0 ? 'af_id=' + i : '')),
        p.parentNode.insertBefore(o, p);
    } as Function
  )(window, document, 'script', 0, 'AF', 'pba', { pba: { webAppId: 'c47c28d8-ba4e-4573-8927-bc303d1677be' } });
}

// 神策 testing
if (isTesting) {
  (function (para) {
    let p = para.sdk_url,
      n = para.name,
      w = window as any,
      d = document,
      s = 'script',
      x: any = null,
      y: any = null;
    if (typeof w['sensorsDataAnalytic201505'] !== 'undefined') {
      return false;
    }
    w['sensorsDataAnalytic201505'] = n;
    w[n] =
      w[n] ||
      function (a: string) {
        return function () {
          (w[n]._q = w[n]._q || []).push([a, arguments]);
        };
      };
    let ifs = [
      'track',
      'quick',
      'register',
      'registerPage',
      'registerOnce',
      'trackSignup',
      'trackAbtest',
      'setProfile',
      'setOnceProfile',
      'appendProfile',
      'incrementProfile',
      'deleteProfile',
      'unsetProfile',
      'identify',
      'login',
      'logout',
      'trackLink',
      'clearAllRegister',
      'getAppStatus',
    ];
    for (let i = 0; i < ifs.length; i++) {
      w[n][ifs[i]] = w[n].call(null, ifs[i]);
    }
    if (!w[n]._t) {
      (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0]);
      x.async = 1;
      x.src = p;
      x.setAttribute('charset', 'UTF-8');
      w[n].para = para;
      y.parentNode.insertBefore(x, y);
    }
  })({
    sdk_url: `${location.origin}/sensor-1.26.1/sensorsdata.min.js`,
    name: 'sensors',
    server_url: 'https://datasink.bitmart.site/sa',
    web_url: 'https://web.bitmart.site/?project=pro',
    app_js_bridge: true,
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default',
      collect_tags: {
        div: {
          max_level: 3, // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理。
        },
        li: true,
        img: true,
        svg: true,
        span: true,
        // ... 其他标签
      },
    },
    is_track_single_page: true,
    use_client_time: true,
    show_log: false,
    send_type: 'ajax',
  });
// TODO 3619
  window.sensors.registerPage({
    // current_url: location.href,
    // referrer: document.referrer,
    platform_type: 'WEB',
    is_login: Cookies.get('accessSalt') ? true : false,
    language: Cookies.get('golang') || window.localStorage.getItem('golang') || 'en',
    $timezone_offset: new Date().getTimezoneOffset(),
  });
  window.sensors && window.sensors.quick('autoTrack');

  window.sensors &&
    window.sensors.quick('isReady', function () {
      window.sensors && window.sensors.use && window.sensors.use('PageLeave');
    });

  // 防止在webview中cookie延迟
  setTimeout(() => {
    if (Cookies.get('accessSalt')) {
      window.sensors &&
        window.sensors.registerPage({
          is_login: true,
        });
    }
  }, 2000);
}

// 神策线上
if (isProd) {
  (function (para) {
    let p = para.sdk_url,
      n = para.name,
      w = window as any,
      d = document,
      s = 'script',
      x: any = null,
      y: any = null;
    if (typeof w['sensorsDataAnalytic201505'] !== 'undefined') {
      return false;
    }
    w['sensorsDataAnalytic201505'] = n;
    w[n] =
      w[n] ||
      function (a: string) {
        return function () {
          (w[n]._q = w[n]._q || []).push([a, arguments]);
        };
      };
    let ifs = [
      'track',
      'quick',
      'register',
      'registerPage',
      'registerOnce',
      'trackSignup',
      'trackAbtest',
      'setProfile',
      'setOnceProfile',
      'appendProfile',
      'incrementProfile',
      'deleteProfile',
      'unsetProfile',
      'identify',
      'login',
      'logout',
      'trackLink',
      'clearAllRegister',
      'getAppStatus',
    ];
    for (let i = 0; i < ifs.length; i++) {
      w[n][ifs[i]] = w[n].call(null, ifs[i]);
    }
    if (!w[n]._t) {
      (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0]);
      x.async = 1;
      x.src = p;
      x.setAttribute('charset', 'UTF-8');
      w[n].para = para;
      y.parentNode.insertBefore(x, y);
    }
  })({
    sdk_url: `${location.origin}/sensor-1.26.1/sensorsdata.min.js`,
    name: 'sensors',
    web_url: 'https://web.bitmart.site/?project=pro',
    server_url: 'https://datasink.bitmart.site/sa?project=pro',
    app_js_bridge: true,
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default',
      collect_tags: {
        div: {
          max_level: 3, // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理。
        },
        li: true,
        img: true,
        svg: true,
        span: true,
        // ... 其他标签
      },
    },
    is_track_single_page: true,
    use_client_time: true,
    show_log: false,
    send_type: 'ajax',
  });

  // 神策初始化
  window.sensors.registerPage({
    // current_url: location.href,
    // referrer: document.referrer,
    platform_type: 'WEB',
    is_login: Cookies.get('accessSalt') ? true : false,
    language: Cookies.get('golang') || window.localStorage.getItem('golang') || 'en',
    $timezone_offset: new Date().getTimezoneOffset(),
  });
  window.sensors && window.sensors.quick('autoTrack');
  window.sensors &&
    window.sensors.quick('isReady', function () {
      window.sensors && window.sensors.use && window.sensors.use('PageLeave');
      // @ts-ignore
      window.aid = window.sensors.quick('getAnonymousID');
      // @ts-ignore
      if (window.aid) {
        // @ts-ignore
        window.localStorage.setItem('getAnonymousID', window.aid);

        setAxiosHeaders({
          // @ts-ignore
          'SENSORS-DISTINCT-ID': window.aid,
        });
      }
    });

  // 防止在webview中cookie延迟
  setTimeout(() => {
    if (Cookies.get('accessSalt')) {
      window.sensors &&
        window.sensors.registerPage({
          is_login: true,
        });
    }
  }, 2000);
}

if (isProd && process.client) {
  // 标记gtag config 是否执行过, 为了配合垃圾Google插件检查，config 只能执行一次
  // @ts-ignore
  if (window.gaCount !== 1) {
    // @ts-ignore
    window.gaCount = 1;

    // Your web app's Firebase configuration
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    // const firebaseConfig = {
    //   apiKey: "AIzaSyCNuIe83fhUH58YZ1aEM9E1NgJEsQBRThk",
    //   authDomain: "bitmart-dev.firebaseapp.com",
    //   databaseURL: "https://bitmart-dev.firebaseio.com",
    //   projectId: "bitmart-dev",
    //   storageBucket: "bitmart-dev.appspot.com",
    //   messagingSenderId: "507633062969",
    //   appId: "1:507633062969:web:306bd8694ece29cb59e9e8",
    //   measurementId: "G-R8QWWJS24Y"
    // };

    // Initialize Firebase
    // const app = initializeApp(firebaseConfig);
    // getPerformance(app);
    // getAnalytics(app);

    // // <!-- Global site tag (gtag.js) - Google Ads -->
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line no-inner-declarations
    function gtag() {
      // @ts-ignore
      window.dataLayer.push(arguments);
    }
    // @ts-ignore
    gtag('js', new Date());
    // gtag('config', 'G-R8QWWJS24Y');
    // @refer: https://firebase.google.com/docs/analytics/get-started?platform=web#firebase-gtag
    // gtag('config', 'G-R8QWWJS24Y');
    // @ts-ignore
    gtag('config', 'AW-807923359', {
      linker: {
        accept_incoming: true,
      },
    });

    // <!-- Google Tag Manager -->
    (function (w: any, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      let f: Element = d.getElementsByTagName(s)[0],
        j: any = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode?.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-WFFJ9N4');

    // <!-- Twitter universal website tag code -->
    // @ts-ignore
    !(function (e: { twq: Function }, t, n, s: any, u: any, a: Element) {
      e.twq ||
        ((s = e.twq =
          function () {
            s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
          }),
        (s.version = '1.1'),
        (s.queue = []),
        (u = t.createElement(n)),
        (u.async = !0),
        (u.src = '//static.ads-twitter.com/uwt.js'),
        (a = t.getElementsByTagName(n)[0]),
        a.parentNode?.insertBefore(u, a));
    })(window, document, 'script');
    // Insert Twitter Pixel ID and Standard Event data below
    // @ts-ignore
    window.twq && window.twq('init', 'o8y1f');
    // @ts-ignore
    window.twq && window.twq('track', 'PageView');

    // Insert Twitter Pixel ID and Standard Event data below
    // @ts-ignore
    window.twq && window.twq('init', 'o9jui');
    // @ts-ignore
    window.twq && window.twq('track', 'PageView');

    // @ts-ignore
    window.twq && window.twq('init', 'o9lp3');
    // @ts-ignore
    window.twq && window.twq('track', 'PageView');
    // @ts-ignore
    window.twq && window.twq('init', 'o9n58');
    // @ts-ignore
    window.twq && window.twq('track', 'PageView');
    // <!-- End Twitter universal website tag code -->

    // <!-- Yandex.Metrika counter -->
    // (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    // m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    //   (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    (function (d, w, c) {
      (w[c] = w[c] || []).push(function () {
        try {
          w.yaCounter89942627 = new window.Ya.Metrika({
            id: 89942627,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true,
          });
        } catch (e) {
          //
        }
      });
      const n = d.getElementsByTagName('script')[0];
      const x = 'https://mc.yandex.ru/metrika/watch.js';
      const s = d.createElement('script');
      const f = function () {
        n.parentNode.insertBefore(s, n);
      };
      for (let i = 0; i < document.scripts.length; i++) {
        if (document.scripts[i].src === x) {
          return;
        }
      }
      s.type = 'text/javascript';
      s.async = true;
      s.src = x;
      if (w.opera == '[object Opera]') {
        d.addEventListener('DOMContentLoaded', f, false);
      } else {
        f();
      }
    })(document, window, 'yandex_metrika_callbacks');

    window.adroll_adv_id = 'DG4F44XG2BFTPCKNR4LF2B';
    window.adroll_pix_id = 'A7Q5K5D3MZE5TMGLZ7UG4J';
    window.adroll_version = '2.0';
    (function (w, d, e, o, a) {
      w.__adroll_loaded = true;
      w.adroll = w.adroll || [];
      w.adroll.f = ['setProperties', 'identify', 'track'];
      let roundtripUrl = 'https://s.adroll.com/j/' + window.adroll_adv_id + '/roundtrip.js';
      for (a = 0; a < w.adroll.f.length; a++) {
        w.adroll[w.adroll.f[a]] =
          w.adroll[w.adroll.f[a]] ||
          (function (n) {
            return function () {
              w.adroll.push([n, arguments]);
            };
          })(w.adroll.f[a]);
      }
      e = d.createElement('script');
      o = d.getElementsByTagName('script')[0];
      e.async = 1;
      e.src = roundtripUrl;
      o.parentNode.insertBefore(e, o);
    })(window, document);
    window.adroll.track('pageView');
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  /*
   ** Only run on client-side and only in production mode
   */
  // if (!isProd && !isTesting) return
  /*
   ** Set the current page
   */
});
